<template>
  <form @submit.prevent="handleSubmit">
    <div class="row">
      <div v-if="sub_route.account" class="form-group col-sm-12 col-md-12">
          <label for="parent_id">Account:</label>
          <input class="form-control" disabled name="account_id" type="text" v-model="sub_route.account.account_name">
      </div>
      <div v-if="sub_route.route" class="form-group col-sm-12 col-md-12">
          <label for="parent_id">Route:</label>
          <input class="form-control" disabled name="route_id" type="text" v-model="sub_route.route.route_name">
      </div>
      <div class="form-group col-sm-12 col-md-6 required">
          <label for="sub_route_name">Route Name:</label>
          <input class="form-control" required="" name="sub_route_name" type="text" v-model="sub_route.sub_route_name">
      </div>
      <div class="form-group col-sm-12 col-md-6 required">
        <label for="sub_route_code">Route Code:</label>
        <input class="form-control" required="" name="sub_route_code" type="text" v-model="sub_route.sub_route_code">
      </div>
      <div class="form-group col-sm-12 col-md-12 required">
        <label for="sub_route_start">Location Start:</label>
        <Select2 name="route_start_id" v-model.number="sub_route.sub_route_start_id" :options="stopOptions" required />
      </div>
      <div class="form-group col-sm-12 col-md-12 required">
        <label for="sub_route_end">Location End:</label>
        <Select2 name="route_start_id" v-model.number="sub_route.sub_route_end_id" :options="stopOptions" required />
      </div>
      <div class="form-group col-sm-12 col-md-6 required">
        <label for="sub_route_distance">Distance (km):</label>
        <input class="form-control" required="" name="sub_route_distance" type="number" step="any" min="0" v-model.number="sub_route.sub_route_distance">
      </div>
      <div class="form-group col-sm-12 col-md-6 required">
        <label for="status">Status:</label>
        <select class="form-control" name="status" v-model.number="sub_route.status">
          <option value="1" style="color:black;">Active</option>
          <option value="2" style="color:black;">Inactive</option>
        </select>
      </div>
      <div class="form-group col-sm-12">
        <input class="btn btn-primary" type="submit" value="Save">
        <router-link class="btn btn-default ml-1" to="/sub_routes">Cancel</router-link>
      </div>
    </div>
    <div v-if="this.onRequest" class="modal-backdrop fade show" style="display:flex; align-items: center; justify-content: center;">
      <img :src="require('../assets/loading.gif')"/>
    </div>
  </form>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import Select2 from 'vue3-select2-component';
  export default {
    computed: {
        ...mapState('sub_routes', ['sub_route', 'onRequest']),
        ...mapState('stops', ['stops']),
    },
    methods: {
      handleSubmit(){
        if(this.onRequest) return;
        this.edit(this.sub_route)
      },
      ...mapActions('sub_routes', ['edit', 'get']),
      ...mapActions('stops', {getStops: 'get_stop_by_route'}),
    },
    data(){
      return {
        stopOptions: [],
      }
    },
    components:{
      Select2
    },
    created() {
      this.$emit('onChildInit', 'Edit Route')
      this.get(this.$route.params.id)
    },
    watch: {
      sub_route (nextState, prevState) {
        if(nextState !== prevState){
          this.getStops({route_id: nextState.route_id})
          return
        }
      },
      stops(nextState, prevState){
        if(nextState !== prevState){
          this.stopOptions = []
          if(nextState.length > 0){
            nextState.map(item => {
              this.stopOptions.push({id:item.id, text:item.stop_name})
            })
          }
          return
        }
      },
    },
  }
</script>
